import { baseApi } from "./BaseApi";
import {
  GetUploadUrlRequest,
  GetUploadUrlResponse,
} from "../types/uploadsTypes";

const uploadsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUploadUrl: builder.mutation<GetUploadUrlResponse, GetUploadUrlRequest>({
      query: (req) => ({
        url: `/uploads/url`,
        method: "POST",
        body: req,
      }),
    }),
    fileUploadComplete: builder.mutation<void, number>({
      query: (uploadId) => ({
        url: `/uploads/${uploadId}/complete`,
        method: "POST",
      }),
      invalidatesTags: ["AdminUserDetails"], // feels hacky
    }),
  }),
});

export const { useGetUploadUrlMutation, useFileUploadCompleteMutation } =
  uploadsApi;

export default uploadsApi;

// const handleSubmit = async () => {
//   if (!imageFile) {
//     alert("Please upload an image first.");
//     return;
//   }

//   // 1. Request presigned URL
//   const res = await fetch("/api/upload-url", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       fileName: imageFile.name,
//       fileType: imageFile.type,
//     }),
//   });

//   const { url, key } = await res.json();

//   // 2. Upload file directly to S3
//   const uploadRes = await fetch(url, {
//     method: "PUT",
//     headers: {
//       "Content-Type": imageFile.type,
//     },
//     body: imageFile,
//   });

//   if (uploadRes.ok) {
//     alert("File uploaded to S3!");
//     // Store `key` in your DB if needed
//   } else {
//     alert("Failed to upload to S3.");
//   }
// };
